// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const VpnBannerConfig = () => (function(config: any) {
   const {
      site
   } = config
   const {
      proxy
   } = config

   return {
      authenticated: config.info.authenticated,
      enabled: site.enable_vpn_banner,
      text: site.vpn_banner,
      bannerUrl: site.vpn_banner_url,
      proxy: {
         url: proxy.url,
         type: proxy.vendor
      }
   }
})

angular.module('summonApp.factories.configs')
   .factory('vpnBannerConfig', VpnBannerConfig)
